/// <amd-module name="VSSUI/Calendar" />
export * from "./Components/Calendar/Calendar";
